<script>
    import IconSave from '@/components/icon/IconSave.vue';
    import { saveFiles } from '@/api/file.js';

    export default {
        computed: {
            fileEdit() {return this.$store.getters.CHECK_EDIT_FILE},
        },
        components: {
            IconSave: IconSave,
        },
        methods: {
            async saveFiles() {
                const response = await saveFiles(
                    this.$store.getters.IMAGES,
                    await this.$store.getters.ASSET_TYPE_IMAGES
                );
                if (response.length > 0) {
                    response.forEach(async (imageValue, imageIndex) => {
                        let saveImage = null;
                        await this.$store.getters.IMAGES.forEach((saveImageValue, saveImageIndex) => {
                            if (saveImageValue.id === imageValue.id) {
                                saveImage = saveImageValue;
                            }
                        });
                        if (saveImage != null) await saveImage.updateFileData(imageValue);
                    });
                }
            }
        }
    }
</script>


<template>
    <button 
        :disabled="fileEdit === false"
        class="left_button_main_container"
        @click="saveFiles"    
    >
        <div class="left_button_icon_container">
            <IconSave 
                icon-height="15px"
                icon-width="15px"
            />
        </div>
        <div class="left_button_label_container">
            <label>Save All</label>
        </div>
    </button>
</template>